import apiClient from "../client";

const objApi = apiClient(
   "/sendMail"
);

export const sendMail = (customer) => {
  try {
      return objApi.get({
        email:customer["email"],
        coupon:customer.coupon,
      });
  } catch(e) {
    // statements
    console.log(e);
  }
};
